
seedWebServices.service('SdSgridService', ['$http', '$cacheFactory',
    function ($http, $cacheFactory) {

        var serviceCache = $cacheFactory('SdSgridService');

        this.resetCache = function () {
            serviceCache.removeAll();
        };

        this.filters = [];

        this.setFilters = function (gridID, filters) {
            this.explodeFilters(gridID);
            var gridFilter = {
                id: gridID,
                filters: filters
            };
            this.filters.push(gridFilter);
        };

        this.getFilters = function (gridID) {
            if (this.filters.length > 0) {
                for (var i = 0; i < this.filters.length; i++) {
                    if (this.filters[i].id == gridID) {
                        var gridFilters = this.filters[i];
                        break;
                    }
                }
                if (gridFilters)
                    return gridFilters.filters;
                else
                    return [];
            } else {
                return [];
            }
        };

        this.appliedFilters = [];

        this.setAppliedFilters = function (gridID, filters) {
            this.explodeFilters(gridID);
            var gridFilter = {
                id: gridID,
                filters: filters
            };
            this.appliedFilters.push(gridFilter);
        };

        this.getAppliedFilters = function (gridID) {
            if (this.appliedFilters.length > 0) {
                for (var i = 0; i < this.appliedFilters.length; i++) {
                    if (this.appliedFilters[i].id == gridID) {
                        var gridFilters = this.appliedFilters[i];
                        break;
                    }
                }
                if (gridFilters)
                    return gridFilters.filters;
                else
                    return [];
            } else {
                return [];
            }
        };

        this.explodeFilters = function (gridID) {
            for (var i = 0; i < this.appliedFilters.length; i++) {
                if (this.appliedFilters[i].id == gridID) {
                    this.appliedFilters.splice(i, 1);
                }
            }
        };

        this.columnFilters = [];

        this.setColumnFilters = function (gridID, column, filters) {
            this.explodeColumnFilters(gridID);
            var gridFilter = {
                id: gridID,
                filters: filters,
                column: column
            };
            this.columnFilters.push(gridFilter);
        };

        this.getColumnFilters = function (gridID, column, options) {
            if (this.columnFilters.length > 0) {
                for (var i = 0; i < this.columnFilters.length; i++) {
                    if (this.columnFilters[i].id == gridID && this.columnFilters[i].column == column) {
                        var gridFilters = this.columnFilters[i];
                        break;
                    }
                }
                if (gridFilters) {
                    this.checkOptions(options, gridFilters.filters);
                    return gridFilters.filters;
                }
                else
                    return [];
            } else {
                return [];
            }
        };

        this.checkOptions = function (options, filters) {
            for (var i = 0; i < options.length; i++) {
                for (var j = 0; j < filters.length; j++) {
                    if (options[i].Value == filters[j].Value) {
                        options[i].IsChecked = true;
                    }
                }
            }
        };

        this.explodeColumnFilters = function (gridID) {
            for (var i = 0; i < this.columnFilters.length; i++) {
                if (this.columnFilters[i].id == gridID) {
                    this.columnFilters.splice(i, 1);
                }
            }
        };

        //this.copiedFilters = [];

        //this.copyFilters = function (filters) {
        //    window.clipboardData.setData("Filters", filters);
        //    this.copiedFilters = filters;
        //};

        //this.pasteFilters = function (column) {
        //    var a = window.clipboardData.getData("Filters");
        //    var pasted = this.copiedFilters.filter(function (filter) { return filter.name == column });
        //    return pasted;
        //};

}]);


